var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { FileRenderElements } from '..';
import { v4 as uuid } from 'uuid';
const FileRenderElement = (_a) => {
    var props = __rest(_a, []);
    const uniqueDivId = uuid();
    React.useEffect(() => {
        const divElement = document.getElementById((props === null || props === void 0 ? void 0 : props.id) || `reveal-${uniqueDivId}`);
        try {
            if (divElement) {
                divElement.innerHTML = '';
            }
            const FileRenderElement = props === null || props === void 0 ? void 0 : props.container.create(Object.assign(Object.assign({}, props.classes), { altText: props.altText || '', skyflowID: props.skyflowID, column: props.column, table: props.table }));
            FileRenderElement.mount(props.id ? `#${props.id}` : `#reveal-${uniqueDivId}`);
            FileRenderElements[props.id] = FileRenderElement;
        }
        catch (e) {
            console.error(e);
        }
    }, []);
    return React.createElement("div", { id: props.id ? props.id : `reveal-${uniqueDivId}` });
};
export default React.memo(FileRenderElement);
//# sourceMappingURL=index.js.map